import { handleClickColor } from "../../Common/Util";

export function BirthPlanetChart ({planetaryPositionData,userData}) {
  return(
    <table class="m-0 p-0 table table-bordered table-hover align-middle caption-top text-center">
      <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Planets</h4></caption>
      <thead class="m-0 p-0">
        <tr class="m-0 p-0">
          <th class="m-0 p-0">Planet</th> 
          <th class="m-0 p-0">Sign Lord</th> 
          <th class="m-0 p-0">Star Lord</th> 
          <th class="m-0 p-0">Sub Lord</th> 
          <th class="m-0 p-0">Sub Sub Lord</th> 
        </tr>
      </thead>
      <tbody class="m-0 p-0">
      {planetaryPositionData.map((planet) => (
        <tr class="m-0 p-0" onClick={handleClickColor}>
          <th class="m-0 p-0 ps-1 bg-transparent text-start text-nowrap">{planet[0]}</th>
          <td class="m-0 p-0 bg-transparent">{planet[6]}</td>
          <td class="m-0 p-0 bg-transparent">{planet[9]}</td>
          <td class="m-0 p-0 bg-transparent">{planet[10]}</td>
          <td class="m-0 p-0 bg-transparent">{planet[11]}</td>
        </tr>
      ))}
      </tbody>  
    </table>
  );
}